import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import Modal from 'react-bootstrap/Modal'
import { Button, Form, Message } from 'semantic-ui-react'
import { CREATE_USER } from '../../../graphql/admin'

const INITIAL_FORM = {
    email: '',
    firstName: '',
    lastName: '',
}

const CreateUserModal = ({ open, onClose, onCreated }) => {
    const [form, setForm] = useState(INITIAL_FORM)
    const [error, setError] = useState('')
    const [createUser, { loading }] = useMutation(CREATE_USER)

    const onChange = (e, { name, value }) => {
        setForm((prevForm) => ({ ...prevForm, [name]: value }))
        setError('')
    }

    const onSubmit = async () => {
        try {
            await createUser({
                variables: {
                    input: {
                        email: form.email.trim(),
                        firstName: form.firstName.trim(),
                        lastName: form.lastName.trim(),
                    },
                },
            })
            setForm(INITIAL_FORM)
            onCreated()
            onClose()
        } catch (err) {
            setError(err.message)
        }
    }

    return (
        <Modal show={open} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form error={Boolean(error)} onSubmit={onSubmit}>
                    <Form.Input
                        required
                        label="Email"
                        name="email"
                        type="email"
                        value={form.email}
                        onChange={onChange}
                    />
                    <Form.Group widths="equal">
                        <Form.Input
                            required
                            label="First name"
                            name="firstName"
                            value={form.firstName}
                            onChange={onChange}
                        />
                        <Form.Input
                            required
                            label="Last name"
                            name="lastName"
                            value={form.lastName}
                            onChange={onChange}
                        />
                    </Form.Group>
                    <p className="auth-user-muted">
                        The user will be created as verified and can set a
                        password later through the normal password setup flow.
                    </p>
                    <Message error content={error} />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button primary loading={loading} onClick={onSubmit}>
                    Create user
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreateUserModal
